import Model from '@/models/Model.js';

export default class ReadReceipt extends Model {
    static entity = 'read_receipts';

    static modelName = 'ReadReceipt';

    static fields() {
        return {
            id: this.attr(null),
            user_id: this.attr(null),
            readable_id: this.attr(null),
            readable_type: this.attr(null),
            readable_type_entity: this.attr(null),

            ...super.fields(),

            user: this.belongsTo('users', 'user_id'),
            readable: this.morphMany('read_receipts', 'readable_id', 'readable_type_entity'),
        };
    }
}
